import toast from "react-hot-toast";
import { environment } from "../environments/environment";

export function showPositiveNotification(message: string): void {
  toast.success(message, {
    duration: 3000,
    position: "top-right",
    style: {
      background: "#10B981",
      color: "white",
    },
  });
}

export function showNegativeNotification(message: string): void {
  // eslint-disable-next-line no-console
  console.error(message);

  toast.error(message, {
    duration: 5000,
    position: "top-right",
    style: {
      background: "#EF4444",
      color: "white",
    },
  });
}

export function showInfoNotification(message: string): void {
  toast(message, {
    duration: 4000,
    position: "top-right",
    icon: "ℹ️",
    style: {
      background: "#3B82F6",
      color: "white",
    },
  });
}

export function wrapError(error: unknown, customMessage?: string): void {
  let message = customMessage ?? "An unknown error occurred";

  if (!environment.production || window.location.hostname === "localhost") {
    if (error instanceof Error) {
      if (error.message) {
        message = error.message;
      } else {
        message = JSON.stringify(error);
      }
    } else if (typeof error === "string") {
      message = error;
    } else if (error && typeof error === "object") {
      message = JSON.stringify(error);
    }
  }

  // eslint-disable-next-line no-console
  console.error("Error details:", error);

  showNegativeNotification(message);
}

export async function withErrorHandling<T>(operation: () => Promise<T>, customMessage?: string): Promise<T | null> {
  try {
    return await operation();
  } catch (error) {
    wrapError(error, customMessage);
    return null;
  }
}
